import { useEffect } from "react"
import { useTableMetadataStore } from "../../_stores"

function RowSelection({ storageObject }) {
	const setIsRowSelectable = useTableMetadataStore(state => state.setIsRowSelectable)
	const selectedRows = useTableMetadataStore(state => state.selectedRows)

	useEffect(() => {
		setIsRowSelectable(true)
	}, [])

	useEffect(() => {
		if (!storageObject) return
		if (typeof storageObject === 'string')
			document.querySelector(storageObject).selectedRows = selectedRows
		if (typeof storageObject === 'function')
			storageObject(selectedRows)
		if (typeof storageObject === 'object')
			storageObject.selectedRows = selectedRows
	}, [selectedRows])

	return null
}

export default RowSelection